import styled from 'styled-components';

export default styled.div`
  .smartplayer__skipIntro {
    position: absolute;
    bottom: 80px;
    right: 16px;
    z-index: 90;
    opacity: 1;
    transform: translateY(0) translateZ(0);
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  }

  .smartplayer__skipIntroButton {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: var(--bg-color);
    border-radius: 8px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: 0;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, transform 0.1s ease-in-out;
    backdrop-filter: blur(4px);
    min-height: 40px;

    &:hover {
      background: rgba(0, 0, 0, 0.9);
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px var(--primary-color, #444CE7);
    }
  }

  .smartplayer__skipIntroText {
    font-family: inherit;
    white-space: nowrap;
    line-height: 1;
  }

  .smartplayer__skipIntroIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    .smartplayer__skipIntro {
      bottom: 70px;
      right: 12px;
    }

    .smartplayer__skipIntroButton {
      padding: 6px 12px;
      font-size: 13px;
      min-height: 36px;
    }
  }

  @media (max-width: 480px) {
    .smartplayer__skipIntro {
      bottom: 60px;
      right: 8px;
    }

    .smartplayer__skipIntroButton {
      padding: 4px 8px;
      font-size: 12px;
      min-height: 32px;
      gap: 6px;
    }

    .smartplayer__skipIntroText {
      display: none;
    }
  }
`;
